import { createContext, useContext } from 'react';

/**
 * Lets mutation completion handlers (create/update/delete of Ads, Line Items, etc.)
 * request a delayed refetch of the Trafficking Table without being coupled to the
 * table query itself. The provider is supplied by the Trafficking page, which owns
 * the table queries and the debounce/delay logic (see useTraffickingTableAutoReload).
 *
 * When consumed outside the Trafficking page (e.g. the standalone Ads page, where no
 * Trafficking Table is mounted) the default no-op is used, so callers never need to
 * branch on whether a table is present.
 */
export interface TraffickingTableReloadContextValue {
  scheduleTableReload: () => void;
}

export const defaultTraffickingTableReloadContextValue: TraffickingTableReloadContextValue = {
  scheduleTableReload: () => undefined,
};

export const TraffickingTableReloadContext = createContext<TraffickingTableReloadContextValue>(
  defaultTraffickingTableReloadContextValue
);

export const useTraffickingTableReload = (): TraffickingTableReloadContextValue =>
  useContext(TraffickingTableReloadContext);
